import { CommonModule } from "@angular/common";
import { UiModule } from "@topyourthree/ui";
import * as i0 from "@angular/core";
export class SectionHeroModule {
}
SectionHeroModule.ɵfac = function SectionHeroModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SectionHeroModule)(); };
SectionHeroModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SectionHeroModule });
SectionHeroModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, UiModule] });
